module.exports = __webpack_public_path__ + "static/media/porteengin.ff9bbdce.png";